module.exports = __webpack_public_path__ + "media/images/landing/icon-dots-25f855e30ee6f06ad6793194ee0913df.svg";